import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StoreReturnInformation } from './store-return-information.dto';
import { StoreReturnDto } from './store-return.dto';

export class AllStoreReturnsResponseModel extends GlobalResponseObject{
    data?: StoreReturnInformation[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status: boolean, errorCode: number, internalMessage: string, data?: StoreReturnInformation[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
